// Central place for environment-driven configuration.
// The backend base URL can be overridden at build/deploy time with
// REACT_APP_API_URL. Defaults to the local dev backend (see the server's
// .env.example — PORT=4000).
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

export default API_URL;
